import { toJSON } from '@utils';
function extractFirst(data) {
    return Array.isArray(data) ? data[0] : data;
}
function parseJson(value, fallback) {
    if (value === null || value === undefined)
        return fallback;
    if (typeof value !== 'string')
        return Array.isArray(value) || typeof value === 'object' ? value : fallback;
    try {
        return JSON.parse(value);
    }
    catch (_a) {
        return fallback;
    }
}
function buildNotificationParams(params) {
    const p = {
        category: params.category,
        max: String(params.max),
        last: params.lastPageToken ? params.lastPageToken : '0',
        unreadOnly: params.unreadOnly ? '1' : '0',
    };
    if (params.search)
        p['q'] = params.search;
    if (params.severity)
        p['severity'] = params.severity;
    return p;
}
export const NotificationServices = {
    getCriteria: {
        type: 'service',
        app: 'System',
        service: 'GetNotificationCriteria',
        parameters: {},
        options: { json: true },
        transformData: (data) => {
            const raw = extractFirst(data);
            const categories = toJSON(raw === null || raw === void 0 ? void 0 : raw.criteria, []);
            return {
                categories: Array.isArray(categories) ? categories : [],
                totalUnread: (raw === null || raw === void 0 ? void 0 : raw.totalUnread) != null ? Number(raw.totalUnread) : 0,
            };
        },
        defaultValue: { categories: [], totalUnread: 0 }
    },
    getNotifications: (params) => ({
        type: 'service',
        app: 'System',
        service: 'GetNotifications',
        parameters: buildNotificationParams(params),
        options: { json: true },
        transformData: (data) => {
            const r = extractFirst(data);
            return {
                notifications: parseJson(r === null || r === void 0 ? void 0 : r.notifications, []),
                nextPageToken: (r === null || r === void 0 ? void 0 : r.nextPageToken) || '',
                total: (r === null || r === void 0 ? void 0 : r.total) != null ? Number(r.total) : undefined,
            };
        },
        defaultValue: { notifications: [], nextPageToken: '', total: undefined }
    }),
    markReadUnread: (notificationId, read) => ({
        type: 'service',
        app: 'System',
        service: 'MarkNotificationRead',
        parameters: { notificationId, read: read ? '1' : '0' },
        options: { json: true },
        transformData: (data) => { var _a, _b; return ((_a = extractFirst(data)) === null || _a === void 0 ? void 0 : _a.success) === true || ((_b = extractFirst(data)) === null || _b === void 0 ? void 0 : _b.success) === 'true'; },
        defaultValue: false
    })
};
